import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Import jQuery
import jQuery from "jquery";
window.$ = jQuery;
window.jQuery = jQuery;

// Import Bootstrap JavaScript only
import "bootstrap";
